/* 曹操傳・第 5 章：宛城外的曹營（淯水，197 年）
 * 曹營用木柵圍成一圈，南面是營門（典韋守在這裡），東、西兩側的木柵各有一處比較單薄的地方；北面有小門通往淯水，曹操從這裡逃。 */
export const CAMP = { x: 3600, y: 2300, hw: 900, hh: 650 };
const T = 30, N = CAMP.y - CAMP.hh, S = CAMP.y + CAMP.hh, Wx = CAMP.x - CAMP.hw, E = CAMP.x + CAMP.hw;
export const GATE = [CAMP.x, S], WEAK = [[Wx, CAMP.y + 150], [E, CAMP.y + 150]], NORTH = [CAMP.x, N], EXIT = [3500, 300];
export default {
  id: 'yushui', name: '淯水', W: 7200, H: 4800, seed: 197,
  bases: [[CAMP.x, CAMP.y], [3600, 4400]],
  walls: [
    [(Wx + NORTH[0] - 110) / 2, N, (NORTH[0] - 110 - Wx) / 2 + T, T], [(NORTH[0] + 110 + E) / 2, N, (E - NORTH[0] - 110) / 2 + T, T],
    [(Wx + GATE[0] - 120) / 2, S, (GATE[0] - 120 - Wx) / 2 + T, T], [(GATE[0] + 120 + E) / 2, S, (E - GATE[0] - 120) / 2 + T, T],
    [Wx, (N + WEAK[0][1] - 120) / 2, T, (WEAK[0][1] - 120 - N) / 2], [Wx, (S + WEAK[0][1] + 120) / 2, T, (S - WEAK[0][1] - 120) / 2],
    [E, (N + WEAK[1][1] - 120) / 2, T, (WEAK[1][1] - 120 - N) / 2], [E, (S + WEAK[1][1] + 120) / 2, T, (S - WEAK[1][1] - 120) / 2],
  ],
  roads: [{ pts: [[3600, 4400], [GATE[0], S + 300], GATE, [CAMP.x, CAMP.y], NORTH, [3500, 900], EXIT], w: 140 }],
  rocks: [[1500, 1200, 380, 180], [5700, 1200, 380, 180], [1500, 3700, 360, 170], [5800, 3700, 360, 170]],
  woods: 0.45,
  sight: 0.6,
  clearings: [[CAMP.x, CAMP.y, 1000], [GATE[0], S + 400, 450], [WEAK[0][0] - 300, WEAK[0][1], 300], [WEAK[1][0] + 300, WEAK[1][1], 300], [3500, 700, 300]],
  tents: [{ x: CAMP.x, y: CAMP.y - 100, n: 10, r: 600, chief: true, col: '#3b5a99', flag: '曹' }],
  rivers: [{ pts: [[-100, 150], [3000, 120], [7300, 160]], hw: 110, fords: [] }],
};
